import React, { useState, useContext }from "react";
import "./styles.css";
import { AuthContext } from "../../contexts/AuthContext";
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import AccountCircle from '@mui/icons-material/AccountCircle';
import LockIcon from '@mui/icons-material/Lock';
import Button from '@mui/material/Button';
import { Link } from "react-router-dom";

function LoginPage() {
    const {authenticated, login} = useContext(AuthContext);

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        login(email, password); // integração com o contexto // API
    }

  return (
    <div id="login">
      <div id="loginContainer">
      <h1 className="title">Login</h1>
      <form onSubmit={handleSubmit} className="form">
      <TextField
        type="email"
        name="email" 
        id="email" 
        value={email} 
        onChange={(e) => setEmail(e.target.value)} 
        label="E-mail"
        fullWidth
        margin="dense"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <AccountCircle />
            </InputAdornment>
          ),
        }}
        variant="standard"
      />
        <TextField
        type="password" 
        name="password" 
        id="password" 
        value={password} 
        onChange={(e) => setPassword(e.target.value)}
        label="Senha"
        fullWidth
        margin="dense"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <LockIcon />
            </InputAdornment>
          ),
        }}
        variant="standard"
      />
        <div className="actions">
          <Button
          type="submit"
          variant="contained"
          id="submit-button"
          fullWidth
          >
          Entrar
          </Button>
        </div>
      </form>
      <Link 
      to="/signUp" 
      id="signUp-link">
        Crie Uma conta
      </Link>
      </div>
    </div>
  );
}

export default LoginPage;
